import type { Tenant } from "@repo/shared-types";
import { Badge } from "@/components/ui/badge";

/**
 * A space's header badges: the viewer's role there, and who can find it.
 * Somebody outside it, on its presentation page, has no role to show.
 */

const ROLES: Record<string, { label: string; variant: "default" | "secondary" | "outline" }> = {
  owner: { label: "Owner", variant: "default" },
  admin: { label: "Admin", variant: "secondary" },
  member: { label: "Member", variant: "outline" },
};

export function SpaceBadges({
  tenant,
  role,
}: {
  tenant: Pick<Tenant, "isPersonal" | "visibility">;
  role?: string;
}) {
  const known = role ? (ROLES[role] ?? { label: role, variant: "outline" as const }) : null;
  const visibility = tenant.isPersonal ? "personal" : tenant.visibility;
  return (
    <div className="flex flex-wrap gap-2">
      {known && (
        <Badge variant={known.variant} title="Your role here">
          {known.label}
        </Badge>
      )}
      <Badge variant={visibility === "public" ? "secondary" : "outline"}>
        {visibility.charAt(0).toUpperCase() + visibility.slice(1)}
      </Badge>
    </div>
  );
}
